import { createColumnHelper } from '@tanstack/react-table'
import { getGoldSetReviewUrl, type GoldSetQueueItem, GoldSetStatusChip } from '~/entities/gold-set'
import { DataTable } from '~/shared/ui'

const columnHelper = createColumnHelper<GoldSetQueueItem>()

const columns = [
  columnHelper.accessor('position', {
    header: 'Position',
    cell: (info) => info.getValue(),
  }),
  columnHelper.accessor('short_key', {
    header: 'Document ID',
    cell: (info) => <span className="whitespace-nowrap">{info.getValue()}</span>,
  }),
  columnHelper.accessor('status', {
    header: 'Status',
    cell: (info) => <GoldSetStatusChip status={info.getValue()} />,
  }),
]

export function QueueTable({ items, pass }: { items: GoldSetQueueItem[]; pass: number }) {
  return (
    <DataTable
      columns={columns}
      data={items}
      withStickyHeader
      getRowUrl={(item) => getGoldSetReviewUrl(item.short_key, pass)}
      noResultsMessage="There are no documents for you in this pass."
    />
  )
}
